var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title",on:{"click":_vm.clickItem}},[(_vm.title)?_c('p',[_vm._v(_vm._s(_vm.title))]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }